// Runtime configuration for the Integration Hub admin UI.
//
// `hubServer` is the base URL prepended to every API path. Leave it empty
// (the default) to call the hub same-origin through the Vite dev proxy
// (`/api → backend:3000`). Set VITE_HUB_SERVICE_URL to call a remote hub
// directly (e.g. https://dev.hub.chatbot.mn) — note that triggers CORS and
// exposes the key in the browser, so it's intended for ad-hoc remote testing.
export const config = {
  hubServer: (import.meta.env.VITE_HUB_SERVICE_URL ?? '').replace(/\/$/, ''),
  /**
   * X-API-Key sent on `key|token` routes (e.g. /api/forms). The hub's api-key
   * is an anti-public-access gate, not a tenant scope. IamOnly routes
   * (tenant-config, user-profile) reject it — see the Memory page note.
   */
} as const;
